<template>
  <app-layout style="padding-top: 0px">
    <div slot="conteudo">
      <v-alert color="blue-grey" style="margin: 0px 5px 5px 5px">
        <h4 style="color: white">Prejulgados</h4>
      </v-alert>
      <v-row style="margin-left: 4px">
        <v-col cols="12" md="5">
          <v-text-field
            v-on:keyup.enter="buscar()"
            label="Pesquisar por Excerto"
            v-model="filtro.livrePesquisa"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            type="number"
            label="Processo"
            v-model="filtro.numeroProcesso"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-on:keyup.enter="buscar()"
            type="number"
            label="Ano"
            v-model="filtro.ano"
          />
        </v-col>
        <!-- <v-col cols="2">
          <v-text-field v-on:keyup.enter="buscar()"
            label="Gestor Responsável" v-model="filtro.gestor" />
        </v-col>
        <v-col cols="2">
          <v-text-field v-on:keyup.enter="buscar()"
            label="Relator" v-model="filtro.relator" />
        </v-col> -->
      </v-row>

      <v-row>
        <v-col cols="5">
          <v-select
            solo
            dense
            v-model="temaSelected"
            :items="listaTema"
            item-text="nome"
            item-value="temaId"
            label="Tema"
            return-object
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-select
            solo
            dense
            v-model="filtro.subtema"
            :items="temaSelected.subTemas"
            item-text="nome"
            item-value="subtemaId"
            label="Subtema"
          ></v-select>
        </v-col>

        <v-col cols="2" style="margin-top: 0.8%">
          <v-btn
            color="primary"
            small
            depressed
            :loading="loadingBusca"
            :disabled="loadingBusca"
            @click="buscar()"
          >
            <v-icon small>fa-search</v-icon>
          </v-btn>

          <v-btn
            style="margin-left: 10px"
            small
            depressed
            color="primary"
            to="/prejulgados/0"
            :disabled="!userHasPermission()"
          >
            <v-icon x-small style="margin-right: 5px">fa-plus</v-icon>
            Novo
          </v-btn>
        </v-col>
      </v-row>

      <template>
        <v-data-table
          :headers="headers"
          :items="lista"
          :items-per-page="5"
          :loading="loadingBusca"
          class="elevation-1"
          no-results-text="A busca não trouxe resultados."
          no-data-text="A busca não trouxe resultados."
        >
          <template v-slot:loading>
            <LoadingSpinner text="Carregando prejulgados... aguarde." />
          </template>
          <template v-slot:item.dataInclusaoFormatada="{ item }">
            <span>
              {{
                item.dataInclusao
                  ? $moment(item.dataInclusao).format("DD/MM/YYYY")
                  : "Não Informado"
              }}
            </span>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Editar</span>
            </v-tooltip>

            <v-icon small @click="deleteItem(item)" :disabled="!userAdm()"> mdi-delete </v-icon>
          </template>
        </v-data-table>
      </template>

      <v-dialog :retain-focus="false" v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="headline"
            >Confirma a exclusão do item?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete"
              >Cancelar</v-btn
            >
            <v-btn color="blue darken-1" text @click="deleteItemConfirm()"
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </app-layout>
</template>

<script>
import excertoService from "@/service/ExcertoService";
import LoadingSpinner from "@/components/template/LoadingSpinner.vue";

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      deleteId: null,
      dialogDelete: false,
      loadingBusca: false,
      temaSelected: {},
      listaTema: [],
      lista: [],

      filtro: {
        livrePesquisa: null,
        subtema: null,
        numeroProcesso: null,
        ano: null,
        exercicioFinanceiro: null,
        gestor: null,
        relator: null,
      },

      headers: [
        /* { text: "Prejulgado.", value: "excertoId", sortable: false }, */
        { text: "Nº Processo", value: "cdProcesso", sortable: false },
        { text: "Ano Processo", value: "cdAno", sortable: false },
        { text: "Natureza", value: "processo.natureza", sortable: false },
        { text: "Origem", value: "processo.unidade", sortable: false },
        { text: "Inclusão", value: "dataInclusaoFormatada", sortable: false },
        {
          text: "Ações",
          value: "actions",
          align: "center",
          sortable: false,
          width: "8%",
        },
      ],
    };
  },
  methods: {
    editItem(item) {
      this.$router.push("/prejulgados/" + item.excertoId);
    },
    deleteItem(item) {
      this.deleteId = item.excertoId;
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      if (this.deleteId != null) {
        excertoService.excluir(this.deleteId);
        this.deleteId = null;
        this.lista = [];
      }
      this.closeDelete();
    },
    buscar() {
      if (this.loadingBusca) return; //evita disparar buscas empilhadas pelo enter
      this.loadingBusca = true;
      this.lista = []; //limpa antes: senão a tabela mostra os resultados antigos + a barra em vez do spinner
      excertoService
        .buscarExcertoFiltro(this.filtro)
        .then((result) => (this.lista = result || []))
        .catch(() => (this.lista = []))
        .finally(() => (this.loadingBusca = false));
    },
    findAllTemas() {
      excertoService.findAllTemas().then((result) => (this.listaTema = result));
    },
    closeDelete() {
      this.dialogDelete = false;
      this.deleteId = null;
      this.$nextTick(() => {
        this.editedIndex = -1;
      });
    },
  },
  created() {
    this.findAllTemas();
  },
  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style></style>
